// extracted by mini-css-extract-plugin
export var container = "styles-module--container--6262f";
export var content = "styles-module--content--c98bf";
export var textContainer = "styles-module--textContainer--bb3a9";
export var title = "styles-module--title--13808";